/**
 * Gallery Types
 */
export const LOAD_IMAGES_SUCCESS = 'LOAD_IMAGES_SUCCESS'
export const IMAGES_LOADING = 'IMAGES_LOADING'
